import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Paper from '@material-ui/core/Paper';

import FlexContainer from '@components/FlexContainer/FlexContainer';

import './TermsOfUse.scss';
import '@components/Link/Link.scss';

const TermsOfUse = () => (
  <div className="terms-of-use">
    <FlexContainer>
      <Paper className="terms-of-use__paper">
        <h2 className="terms-of-use__title">
          Terms Of Use
        </h2>
        <p className="terms-of-use__paragraph">
          Process General LLC (&quot;PG&quot;) provides the information and services on
          its websites under the following terms and conditions governing your use of
          any PG website and the information you provide to PG. By using any PG website,
          you agree to adhere to and be bound by the terms and conditions herein. PG
          reserves the right to modify these terms and conditions at any time and you
          should check periodically for changes. By using any PG website after PG posts
          changes to the terms and conditions, you agree to accept those changes even
          if you have not reviewed them. The failure of PG to insist upon strict
          compliance with any terms of this Agreement shall not be construed as a waiver
          with respect to any subsequent failure to comply with such term or provision.
        </p>
        <p className="terms-of-use__paragraph">
          By using any PG website, you also consent to the terms of PG&apos;s
          &nbsp;
          <RouterLink
            to="/privacy-policy"
            className="link"
          >
            Privacy Policy
          </RouterLink>
          &nbsp;
          regarding the collection, use, and processing of personal information. You
          further expressly agree that your rights and obligations, as well as the
          rights and obligations of PG, shall be governed, at PG&apos;s sole discretion,
          by the laws of the State of Nevada.
        </p>
        <p className="terms-of-use__paragraph">
          These terms represent the entire understanding concerning the use of PG
          websites and prevail over any prior or contemporaneous, conflicting or
          additional, communications. If you do not agree with these terms and conditions,
          please do not use any PG website. Please be aware that PG reserves any
          rights not expressly granted herein.
        </p>
        <h3 className="terms-of-use__header">
          Use Restrictions
        </h3>
        <p className="terms-of-use__paragraph">
          All materials on any PG website including, but not limited to, resources,
          information, documents, products, logos, graphics, sounds, images, software,
          tools, modules, and services (&quot;Materials&quot;) are protected by copyright and
          other intellectual property laws. Except as stated herein, none of the Materials may
          be copied, reproduced, distributed, republished, downloaded, displayed, posted,
          or transmitted in any form or by any means without the prior express written
          permission of PG. Any unauthorized use of any Materials may violate copyright
          laws, trademark laws, the laws of privacy and publicity, and communications
          regulations and statutes. You may not &quot;mirror&quot; any Materials on any other
          server without PG&apos;s prior express written permission. You may not access or use
          any PG website or any Materials in any manner that could damage, disable,
          overburden, or impair any PG server, or the network(s) or system(s) connected
          to any PG server, or interfere with any other party&apos;s use and enjoyment of any
          PG website or any products or services provided by PG. Any use of direct or
          indirect automated searches or data queries is strictly prohibited without
          PG&apos;s prior written consent. You may not attempt to gain unauthorized access to
          any services, accounts, computer systems, or networks connected to any PG server
          or network or to any PG website or any of the Materials, through hacking,
          password mining, or any other means. You may not obtain or attempt to obtain
          any Materials or information through any means not intentionally
          and publicly made available.
        </p>
        <h3 className="terms-of-use__header">
          Accuracy of Materials
        </h3>
        <p className="terms-of-use__paragraph">
          PG does not guarantee or warrant that the Materials provided herein are
          accurate, complete, or current and shall not be liable to you for any loss
          or injury arising out of or caused in whole or in part by the acts, errors,
          or omissions of PG, whether negligent or otherwise, in procuring, compiling,
          gathering, formatting, interpreting, reporting, communicating, or delivering
          the information contained in any PG website. PG does not undertake any
          obligation to update, modify, revise, or reorganize the information provided
          herein, or to notify you or any third party should the information be updated,
          modified, revised, or reorganized. Materials are provided &quot;as is&quot;
          and PG disclaims all express or implied representations, warranties, and guaranties.
        </p>
        <h3 className="terms-of-use__header">
          Links
        </h3>
        <p className="terms-of-use__paragraph">
          PG websites may contain hyperlinks to other websites. These links are provided
          solely for informational purposes and such inclusion does not imply that PG
          endorses or accepts responsibility for the content or use of the third party
          website. PG does not guarantee the content, accuracy, or completeness of any
          information or data on the third party website. It is your responsibility to take
          precautions to ensure that whatever you select for your use is free of viruses or
          other items of a destructive nature.
        </p>
        <h3 className="terms-of-use__header">
          Submissions
        </h3>
        <p className="terms-of-use__paragraph">
          All comments, feedback, or information submitted to PG through or in association
          with any PG website (&quot;Submissions&quot;) shall be considered non-confidential
          and the sole property of PG. By providing such Submissions to PG, you agree to
          assign to PG, effective immediately upon such submission, at no charge, all
          worldwide rights, title, and interest in copyrights and other intellectual
          property rights to the Submissions and represent and warrant that you have all
          necessary ownership rights, consents, and authority to assign all such rights,
          title, and interest to PG. PG shall be free to use and disseminate such
          Submissions on an unrestricted basis for any purpose. You acknowledge that you
          are responsible for the Submissions that you provide, and that you, not PG,
          have full responsibility for the Submissions, including their legality,
          reliability, appropriateness, originality, and copyright.
        </p>
        <h3 className="terms-of-use__header">
          No Advice
        </h3>
        <p className="terms-of-use__paragraph">
          PG is not in the business of providing professional or legal advice and no
          website should be relied on as a substitute for financial, legal, or other
          professional advice. Any reliance on the information contained is solely at your risk.
        </p>
        <h3 className="terms-of-use__header">
          Limitation of Liability
        </h3>
        <p className="terms-of-use__paragraph">
          PG and its affiliates and their respective officers, directors, employees,
          agents, and representatives (&quot;PG Parties&quot;) shall not be liable for any
          damages suffered because of your access or use of any PG website or accessing,
          using, modifying, contributing, copying, distributing, or downloading the Materials.
          In no event shall the PG Parties be liable for any indirect, punitive, special,
          incidental, or consequential damage, however it arises, whether in an action of
          contract, negligence, or other tortious action, arising out of or in connection
          with the access to, use of, performance of, or information available from any PG
          website, even if any PG Party has been previously advised of the possibility of
          such damage. You have sole responsibility for the adequate protection and backup
          of data and equipment used in connection with any PG website and Materials and you
          will not make a claim against any PG Party for lost or corrupted data or systems,
          loss of goodwill, re-run time, inaccurate output, work delays, or lost profits
          resulting from the use of any PG website or Materials. You agree to hold the PG
          Parties harmless from, and you covenant not to sue PG for, any claims and threatened
          claims arising out of or related to all access and use of any PG website
          and Materials in any manner.
        </p>
        <h3 className="terms-of-use__header">
          Legal Contact Information
        </h3>
        <p className="terms-of-use__paragraph">
          If you have any questions regarding the Terms of Use, or if you would like to
          request permission to use any Materials, please contact the
          PG Legal Department at (855) 485-4850.
        </p>
      </Paper>
    </FlexContainer>
  </div>
);

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/routes/TermsOfUse/TermsOfUse.js